// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__3QWGj","active":"tooltip_active__10n7o"};